<template>
  <v-layout row wrap>
    <!-- Actions List -->
    <v-flex :xs10="!actionDetailsSheet" :xs5="actionDetailsSheet">
      <v-data-table :headers="actionsHeaders" :items="actions" ref="draggableTable">
        <template v-slot:items="props">
          <tr :active="!!selectedAction && selectedAction.id == props.item.id" class="pointer"
            @click="showActionDetailsSheet(props.item)">
            <td class="handle" style="max-width: 28px">
              <v-icon>drag_handle</v-icon>
            </td>
            <td class="text-xs-center">{{ props.item.sequence + 1 }}</td>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left">{{ props.item.actionType }}</td>
            <td class="text-xs-left" v-if="!actionDetailsSheet">
              {{ props.item.field }}
            </td>
            <td class="justify-center layout px-0 pointer" width="10%">
              <v-icon small @click.stop="showActionDetailsSheet(props.item)" class="mr-2">
                mdi-circle-edit-outline
              </v-icon>
              <v-icon small @click.stop="showDeleteActionDialog(props.item)" class="error--text text--lighten-1 mr-1">
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_ACTIONS }}
          </v-alert>
        </template>
      </v-data-table>
    </v-flex>
    <!-- Actions Details Sheet -->
    <v-flex xs7 v-show="actionDetailsSheet">
      <ActionDetails />
    </v-flex>
    <v-flex xs2 class="text-xs-left" v-show="!actionDetailsSheet">
      <v-btn color="primary" flat round @click="showActionDetailsSheet()">
        <v-icon left>add_circle</v-icon><span>{{ messages.label.ADD_ACTION }}</span>
      </v-btn>
    </v-flex>
    <!-- Delete dialog -->
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="subheading ttu">
          {{ messages.label.DELETE_ACTION }}
        </v-card-title>
        <v-card-text>
          <p>
            {{ messages.info.DELETE_ACTION_MSG }}
            <b>{{ actionToDelete.title }}</b> ?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 white--text" @click="deleteDialog = false">
            {{ messages.label.CANCEL }}
          </v-btn>
          <v-btn color="error" @click="deleteAction(actionToDelete)">
            {{ messages.label.DELETE }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import messages from "@/MetadataRules/messages.json"
import ActionDetails from "@/MetadataRules/Rule/ActionDetails"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import Sortable from "sortablejs"

export default {
  name: "RuleActions",
  components: {
    ActionDetails
  },
  data() {
    return {
      actionDetailsSheet: false,
      deleteDialog: false,
      selectedAction: {},
      actionToDelete: {},
      actions: []
    }
  },
  computed: {
    actionsHeaders() {
      return this.getActionsHeaders()
    }
  },
  methods: {
    /**
     * getActionsHeaders - Actions data table headers
     * @returns {array}
     */
    getActionsHeaders() {
      let defaultHeaders = [
        {
          text: "",
          align: "left",
          sortable: false
        },
        {
          text: "Sequence",
          align: "center",
          value: "sequence"
        },
        {
          text: "Title",
          align: "left",
          value: "title"
        },
        { text: "Type", value: "actionType" }
      ]
      if (this.actionDetailsSheet) {
        defaultHeaders.push({ text: "", sortable: false })
        return defaultHeaders
      } else {
        defaultHeaders.push({ text: "Field", value: "field" })
        defaultHeaders.push({ text: "", sortable: false })
        return defaultHeaders
      }
    },

    /**
     * showActionDetailsSheet - Show action details
     */
    showActionDetailsSheet(action) {
      if (!this.$lodash.isUndefined(action)) {
        this.selectedAction = action
      } else {
        this.selectedAction = {}
      }
      this.actionDetailsSheet = true
      MetadataRulesService.$emit("event:showActionDetailsSheet", action)
    },

    /**
     * hideActionDetailsSheet - Hide action details view
     */
    hideActionDetailsSheet() {
      this.actionDetailsSheet = false
      this.selectedAction = {}
    },

    /**
     * resetData - Reset data
     */
    resetData() {
      this.selectedAction = {}
      this.actions = []
    },

    /**
     * addAction - Add new action
     * @param {object} action
     */
    addAction(action) {
      this.actions.push(action)
      this.resetActionSequenceNumbers()
      this.sortActionsOnSequence()
    },

    /**
     * Reset / update sequence numbers
     */
    resetActionSequenceNumbers() {
      if (this.actions.length > 0) {
        this.$lodash.forEach(this.actions, (action, index) => {
          action["sequence"] = index
        })
      }
    },

    /**
     * Sort actions based on sequence number
     */
    sortActionsOnSequence() {
      if (this.actions.length > 0) {
        let sortedList = this.$lodash.sortBy(this.actions, "sequence")
        this.actions = []
        this.$nextTick(() => {
          this.actions = sortedList
        })
      }
    },

    /**
     * updateAction - Update existing action
     * @param {object} action
     */
    updateAction(action) {
      let actionIndex = -1
      actionIndex = this.$lodash.findIndex(this.actions, actionObj => {
        return actionObj.id === action.id
      })
      if (actionIndex !== -1) {
        this.actions.splice(actionIndex, 1, action)
      }
      this.resetActionSequenceNumbers()
      this.sortActionsOnSequence()
    },

    /**
     * showDeleteActionDialog - Show dialog to delete action
     */
    showDeleteActionDialog(action) {
      this.deleteDialog = true
      this.actionToDelete = action
    },

    /**
     * deleteAction - Delete existing action
     * @param {object} action
     */
    deleteAction(action) {
      let actionIndex = -1
      actionIndex = this.$lodash.findIndex(this.actions, actionObj => {
        return actionObj.id === action.id
      })
      if (actionIndex !== -1) {
        this.actions.splice(actionIndex, 1)
        this.deleteDialog = false
        this.hideActionDetailsSheet()
        MetadataRulesService.$emit("event:displaySaveRuleMsg")
      }
      this.resetActionSequenceNumbers()
      this.sortActionsOnSequence()
    },

    /**
     * loadActionsData - load actions
     */
    loadActionsData(data) {
      this.resetData()
      // NOTE: Parse actions object from string to object
      if (
        !this.$lodash.isUndefined(data) &&
        data.actions.length > 0 &&
        data.type !== "TRANSFORMATION_JS"
      ) {
        this.actions = MetadataRulesService.parseArrayOfStrings(
          data.actions,
          true
        )
        this.resetActionSequenceNumbers()
      }
    },

    /**
     * validateActions -
     */
    validateActions() {
      // NOTE: For now passing 'true' but need to comeback and re-evaluate
      // Always send sorted list
      let sortedList = this.$lodash.sortBy(this.actions, "sequence")
      MetadataRulesService.$emit(
        "event:ruleActionsValidation",
        true,
        sortedList
      )
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    MetadataRulesService.$on("event:ruleDataRetrieved", this.loadActionsData)
    MetadataRulesService.$on("event:validteActions", this.validateActions)
    MetadataRulesService.$on("event:addAction", this.addAction)
    MetadataRulesService.$on("event:updateAction", this.updateAction)
    MetadataRulesService.$on("event:deleteAction", this.deleteAction)
    MetadataRulesService.$on(
      "event:hideActionDetailsSheet",
      this.hideActionDetailsSheet
    )
  },
  beforeDestroy() {
    MetadataRulesService.$off("event:ruleDataRetrieved", this.loadActionsData)
    MetadataRulesService.$off("event:validteActions", this.validateActions)
    MetadataRulesService.$off("event:addAction", this.addAction)
    MetadataRulesService.$off("event:updateAction", this.updateAction)
    MetadataRulesService.$off("event:deleteAction", this.deleteAction)
    MetadataRulesService.$off(
      "event:hideActionDetailsSheet",
      this.hideActionDetailsSheet
    )
  },
  mounted() {
    let table = this.$refs.draggableTable.$el.getElementsByTagName("tbody")[0]
    const _self = this
    Sortable.create(table, {
      handle: ".handle", // Use handle so user can select text
      onEnd({ newIndex, oldIndex }) {
        const rowSelected = _self.actions.splice(oldIndex, 1)[0] // Get the selected row and remove it
        _self.actions.splice(newIndex, 0, rowSelected) // Move it to the new index
        _self.resetActionSequenceNumbers()
        _self.sortActionsOnSequence()
      }
    })
  }
}
</script>
<style scoped>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/MetadataRules/Rule/RuleActions.vue